import React from "react";
import { ThemeProvider } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core/styles";

const THEME = createMuiTheme({
  typography: {
    fontFamily: ' "Tajawal-Black" \\sans-serif',
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },

  overrides: {
    MuiRadio: {
      root: {
        padding: "4px",
      },
    },
    MuiSvgIcon: {
      root: {
        width: "1rem",
        height: "1rem",
      },
    },
    MuiFormControl: {
      root: {
        margin: "0.3rem 0",
      },
    },
  },
});

export default function ({ children }: any) {
  return <ThemeProvider theme={THEME}>{children}</ThemeProvider>;
}
